import { AppRoute } from '@launchpad';
import React from 'react';
import { Switch } from 'react-router-dom';
import AuthorisationFileDetails from './pages/files/AuthorisationFileDetails';
import AuthorisationFilesList from './pages/files/AuthorisationFilesList';
import AuthorisationImportDashboard from './pages/AuthorisationImportDashboard';

export default class AuthorisationImportNavigation extends React.PureComponent {
  render() {
    return (
      <Switch>
        <AppRoute
          path="/authorisation-import/files/:id"
          component={AuthorisationFileDetails}
        />
        <AppRoute
          path="/authorisation-import/files"
          component={AuthorisationFilesList}
        />
        <AppRoute
          path="/authorisation-import"
          component={AuthorisationImportDashboard}
        />
      </Switch>
    );
  }
}
